// extracted by mini-css-extract-plugin
export default {"fwrAuthHeader":"AccountSetupNew_fwrAuthHeader__NC4Gf","fwrLogo":"AccountSetupNew_fwrLogo__1Omls","fwrkLogin":"AccountSetupNew_fwrkLogin__1626m"};